import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import * as Actions from './redux-actions.js'
import * as helpers from './helpers.js'
import * as globals from './globals.js'


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white"
  },
}));


function Login(props) {
  const inputClass = useStyles()
  const authenticated = useSelector(state => state.authenticated)
  const dispatch = useDispatch()
  const serverStatus = useSelector(state => state.serverStatus)
  const [formPosted, setFormPosted] = useState(false);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [validity, setValidity] = useState({login_Email: true,
                                            login_Password: true})


  let form = {login_Email: null,
  	          login_Password: null}


  var handleSubmit = (e) => {
    
    let validateObject = {login_Email: helpers.validate("email", form.login_Email.value),
                 login_Password: helpers.validate("password", form.login_Password.value)}

    setValidity(validateObject)

    if (! helpers.validate("all_valid", validateObject)) {
       helpers.alertMessage('Please enter all required fields!', globals.ERRO, true, 10000)
       return
    }


    let Data = helpers.mapFormToData(form)

    console.log('DEBUG', 'SEND TO SERVER', Data )
  
 
    setApiCallInProgress(true)
    helpers.postAPI(
         { func: function(data, resp) {
              setApiCallInProgress(false)
              //After receiving response from server
              console.log('DEBUG','RESPONSE',resp)
              if (data.status === 'OK') {
              	  dispatch({type: Actions.LOGIN, user: data.user, role:data.role})
                  helpers.closeMessage()
                  helpers.alertMessage('Welcome.', globals.INFO, true, 5000)
              } else if (resp.statusCode === 401) {
                  //handleLogout()
                  helpers.closeMessage()
                  helpers.alertMessage('Incorrect username or password.', globals.ERRO, true, 5000)
              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+data.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/login',
           data: Data
         })

  }



  return (
    <div className="section">
     <div className="columns is-centered">
     <div className="column is-4 has-background-light" style={{padding: "1.5rem"}}>
  	
  	  
  	  <div class="field">   
       <div class="control"> 
         <TextField
          className = {inputClass.root}
          inputRef = {(c)=>form.login_Email = c}
          error = {! validity.login_Email}
          helperText = {(validity.login_Email) ? null : "Enter your email"}
          required
          fullWidth={true}
          type="text"
          id="login-email"
          label="Email"
          variant="outlined"
        />
      </div>
     </div>

     <div class="field">
      <div class="control"> 
        <TextField
          className = {inputClass.root}
          inputRef = {(c)=>form.login_Password = c}
          error = {! validity.login_Password}
          helperText = {(validity.login_Password) ? null : "Password is required"}
          required
          fullWidth={true}
          id="login-password"
          label="Password"
          type="password"
          autoComplete="current-password"
          variant="outlined"
        />
      </div>
     </div>

     
     <div class="columns is-mobile is-centered">
      <div class="column is-half has-text-centered">
        <Button disabled={apiCallInProgress || !serverStatus || authenticated} onClick={handleSubmit} color="primary">Login</Button> 
      </div>
    </div>
     

    </div>
</div>
</div>
  )

}

export default Login